<template>
    <section class="section-material-text" v-if="isShow">
        <div class="content-box">
            <h2>专属链接</h2>
            <div class="material-box">
                <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide class="material-item" v-for="(item, index) in materialText" :key="index">
                        <div class="material-txt">
                            <p>{{ item.text }}</p>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="icon-left" v-show="isLeft" @click="slidePrev"></div>
                <div class="icon-right" v-show="isRight && materialText.length > 1" @click="slideNext"></div>
            </div>
            <div class="change-one" @click="onChangeOne" v-if="materialText && materialText.length > 1">换一个</div>
            <div class="change-one empty" v-else></div>
            <div class="bt-box">
                <button class="cancel" @click="close">取消</button>
                <button
                    class="copy copy-share-text"
                    :data-clipboard-text="shareMaterialText"
                    @click="onCopy(shareMaterialText)"
                >
                    复制
                </button>
            </div>
        </div>
        <div class="mark"></div>
    </section>
</template>
<script>
import Clipboard from 'clipboard';
import env from '@/common/util/env';
import { compareVersion, getAppVersion } from '@/common/util/getAppVersion';

export default {
    name: 'material-text',
    props: {
        materialText: {
            type: Array,
        },
        onShareSuccess: {
            type: Function,
        },
    },
    data() {
        let self = this;
        return {
            isShow: false,
            shareMaterialText: this.materialText[0] && this.materialText[0].text ? this.materialText[0].text : '',
            isLeft: false,
            isRight: true,
            scrollH: 0,
            swiperActive: 0,
            isChanging: true,
            swiperOption: {
                prevButton: '.icon-left',
                nextButton: '.icon-right',
                slidesPerView: 1,
                paginationClickable: true,
                spaceBetween: 30,
                direction: 'horizontal',
                mousewheelControl: true,
                on: {
                    slideChangeTransitionStart: function() {
                        self.swiperActive = this.activeIndex;
                        self.shareMaterialText = self.materialText[self.swiperActive].text;
                        self.isLeft = this.activeIndex != 0;
                        self.isRight = this.activeIndex != self.materialText.length - 1;
                    },
                },
            },
            env,
        };
    },
    mounted() {},
    methods: {
        show() {
            this.isShow = true;
            this.scrollH = document.body.scrollTop == 0 ? document.documentElement.scrollTop : document.body.scrollTop;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            document.querySelector('body').setAttribute('class', 'fixed');
            document.querySelector('html').setAttribute('class', 'fixed');
            setTimeout(() => {
                if (!this.shareMaterialText) {
                    this.shareMaterialText = this.materialText[0].text;
                }
            }, 100);
        },
        close() {
            document.querySelector('body').setAttribute('class', '');
            document.querySelector('html').setAttribute('class', '');
            document.body.scrollTop = document.documentElement.scrollTop = this.scrollH;
            this.isShow = false;
            this.isLeft = false;
            this.isRight = true;
        },
        onCopy(content) {
            // 2.5.0 或以上的 app
            if (env.isApp && compareVersion(getAppVersion(), '2.5.0') >= 0 && window.zzc) {
                this.onAppCopy(content);
            } else {
                this.onH5Copy();
            }
            this.close();
        },
        onH5Copy() {
            let clipboard = new Clipboard('.copy-share-text');
            clipboard.on('success', this.handleCopySuccess);
            clipboard.on('error', e => {
                console.error('Action:', e.action);
                console.error('Trigger:', e.trigger);
            });
        },
        onAppCopy(content) {
            window.zzc &&
                window.zzc.call('base_setNativeClipboard', {
                    content,
                    success: this.handleCopySuccess,
                });
        },
        handleCopySuccess() {
            if (env.isApp) {
                window.ZZCFL.Dialog(
                    {
                        title: '复制成功',
                        message: '现在就打开微信分享吧~',
                        showConfirmButton: !env.isHarmoneyQskApp,
                        showCancelButton: true,
                        confirmButtonText: '打开微信',
                        cancelButtonText: '取消',
                        closeOnClickModal: false,
                    },
                    value => {
                        if (value === 'confirm') {
                            window.location.href = 'weixin://';
                            this.$emit('onShareSuccess');
                        }
                    }
                );
            } else {
                window.ZZCFL.Toast({ message: '文案已复制 快去分享给朋友吧～', duration: 1500 });
                this.$emit('onShareSuccess');
            }
        },
        slidePrev() {
            this.$refs['mySwiper'].swiper.slidePrev();
        },
        slideNext() {
            this.$refs['mySwiper'].swiper.slideNext();
        },
        onChangeOne() {
            if (!this.isChanging) {
                return false;
            }
            this.isChanging = false;
            let swiperActive = this.swiperActive + 1;
            if (swiperActive == this.materialText.length) {
                this.$refs['mySwiper'].swiper.slideTo(0, 1000, true);
                this.isChanging = true;
            } else {
                this.$refs['mySwiper'].swiper.slideNext();
                this.isChanging = true;
            }
        },
    },
};
</script>
<style lang="scss">
// 分享文案弹窗
.fixed {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
}
.section-material-text {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    .content-box {
        width: 6.3rem;
        background-color: #fff;
        border-radius: 0.16rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        z-index: 101;
        h2 {
            line-height: 0.32rem;
            font-size: 0.32rem;
            color: #333;
            text-align: center;
            padding: 0.4rem 0 0.3rem;
        }
        .material-box {
            width: 100%;
            padding: 0 0.5rem;
            position: relative;
            box-sizing: border-box;

            .material-item {
                width: 100%;
                display: block;
                height: 2.78rem;
                background: rgba($color: #ddc47d, $alpha: 0.1);
                border-radius: 0.08rem;
                padding: 0.2rem;
                position: relative;
                box-sizing: border-box;

                &:after {
                    width: 4.9rem;
                    height: 0.47rem;
                    content: '';
                    background: linear-gradient(rgba($color: #f8f6ed, $alpha: 0), rgba($color: #fbf8ed, $alpha: 1));
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate3d(-50%, 0, 0);
                }
                .material-txt {
                    width: 100%;
                    height: 100%;
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                }
                p {
                    line-height: 0.4rem;
                    font-size: 0.28rem;
                    color: #936022;
                    text-align: justify;
                    word-break: break-all;
                }
            }
            .icon-left {
                width: 0.24rem;
                height: 0.34rem;
                background: url('../../assets/images/sharePop/icon-arrow-r.png') no-repeat center;
                background-size: 0.12rem 0.34rem;
                position: absolute;
                top: 50%;
                left: 0.1rem;
                transform: translate3d(0, -50%, 0) rotate(180deg);
            }
            .icon-right {
                width: 0.24rem;
                height: 0.34rem;
                background: url('../../assets/images/sharePop/icon-arrow-r.png') no-repeat center;
                background-size: 0.12rem 0.34rem;
                position: absolute;
                top: 50%;
                right: 0.1rem;
                transform: translate3d(0, -50%, 0);
            }
        }
        .change-one {
            width: 1.44rem;
            line-height: 0.56rem;
            border-radius: 0.56rem;
            text-align: center;
            color: #fff;
            font-size: 0.28rem;
            margin: 0.17rem auto 0.33rem;
            background: #ddc47d;

            &.empty {
                height: 0.2rem;
                background: #fff;
            }
        }
        .bt-box {
            display: flex;
            button {
                flex-grow: 1;
                line-height: 1rem;
                font-size: 0.32rem;
                text-align: center;
                border-top: 1px solid rgba($color: #dde0e6, $alpha: 0.5);
            }
            .cancel {
                border-right: 1px solid rgba($color: #dde0e6, $alpha: 0.5);
            }
            .copy {
                color: #d19a09;
                font-weight: bold;
            }
        }
    }
    .mark {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: #000;
        opacity: 0.7;
        z-index: 100;
    }
}
</style>
